/* eslint-disable react/destructuring-assignment */
import React from 'react';
import Avatar from 'react-avatar';
import { Checkbox } from '@material-ui/core';
import ResponsibleKinshipSelection from '../../../shared/components/form/ResponsibleKinshipSelection';

export default function (t, onStateUpdate) {
  return [
    {
      render: (rowData) => (
        <Avatar
          size="40"
          round="20px"
          src={rowData.student.profilePhotoUrl}
          name={rowData.student.fullName}
        />
      ),
    },
    { title: t('general.student'), field: 'student.fullName' },
    {
      title: t('general.access-student-data'),
      field: 'accessStudentData',
      render: (rowData) => (
        <Checkbox
          name="accessStudentData"
          checked={rowData.accessStudentData}
          onChange={(event, value) => {
            const newData = {
              ...rowData,
              accessStudentData: value,
            };
            onStateUpdate(rowData, newData);
          }}
        />
      ),
    },
    {
      title: t('general.take-student'),
      field: 'takeStudent',
      render: (rowData) => (
        <Checkbox
          name="takeStudent"
          checked={rowData.takeStudent}
          onChange={(event, value) => {
            const newData = {
              ...rowData,
              takeStudent: value,
            };
            onStateUpdate(rowData, newData);
          }}
        />
      ),
    },
    {
      title: t('general.financial-contact'),
      field: 'financialContact',
      render: (rowData) => (
        <Checkbox
          name="financialContact"
          checked={rowData.financialContact}
          onChange={(event, value) => {
            const newData = {
              ...rowData,
              financialContact: value,
            };
            onStateUpdate(rowData, newData);
          }}
        />
      ),
    },
    {
      title: t('general.emergency-contact'),
      field: 'emergencyContact',
      render: (rowData) => (
        <Checkbox
          name="emergencyContact"
          checked={rowData.emergencyContact}
          onChange={(event, value) => {
            const newData = {
              ...rowData,
              emergencyContact: value,
            };
            onStateUpdate(rowData, newData);
          }}
        />
      ),
    },
    {
      title: t('general.bond'),
      field: 'type',
      render: (rowData) => (
        <ResponsibleKinshipSelection
          t={t}
          type={rowData.type ? rowData.type : null}
          changeHandler={(value) => {
            const newData = {
              ...rowData,
              type: value,
            };
            onStateUpdate(rowData, newData);
          }}
        />
      ),
    },
  ];
}
